import React, { useState } from 'react';

import { useAppSelector, useAppDispatch } from '../../app/hooks';
import {
	Note as NoteI,
  decrement,
  select,
  addNotes,
  //AddNotesAction,
  incrementByAmount,
  incrementAsync,
  incrementIfOdd,
  selectCount,
  selectNotes,
  testAddNotesPayload,
} from './noteSlice';


export function NotesListColumn() {
  const dispatch = useAppDispatch();

  const notes = useAppSelector(selectNotes);
  console.log('notes: ', notes);
  return (
    <div>
		Notes List Column
    </div>
  );
}
